"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TreeFilter = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Form_1 = require("../../../legacy/Form");
var Tree_1 = require("../../../components/Tree");
var R = __importStar(require("../../../utils/ramda"));
var react_1 = require("react");
var Wrapper_1 = require("./Wrapper");
var TriStateCheckbox_1 = require("../../../components/TriStateCheckbox");
var Row_1 = require("../../../components/Row");
var Stack_1 = require("../../../components/Stack");
var useFilter_1 = require("./useFilter");
var useRandomGuid_1 = require("../../../hooks/useRandomGuid");
var Clickable_1 = require("../../../components/Clickable");
var TreeFilter = function (_a) {
  var options = _a.options,
    restProps = __rest(_a, ["options"]);
  // this forces the tree to re-render from scratch if the options have changed
  var _b = __read((0, useRandomGuid_1.useRandomGuid)(), 2),
    key = _b[0],
    refresh = _b[1];
  (0, react_1.useEffect)(refresh, [options]);
  return (0, jsx_runtime_1.jsx)(TreeFilterInner, __assign({
    options: options
  }, restProps), key);
};
exports.TreeFilter = TreeFilter;
var TreeFilterInner = function (_a) {
  var label = _a.label,
    filterId = _a.id,
    placeholder = _a.placeholder,
    options = _a.options,
    _b = _a.defaultOptions,
    defaultOptions = _b === void 0 ? [] : _b,
    _c = _a.startExpanded,
    startExpanded = _c === void 0 ? false : _c,
    tooltip = _a.tooltip,
    tooltipIcon = _a.tooltipIcon,
    tooltipColor = _a.tooltipColor,
    tooltipIconColor = _a.tooltipIconColor,
    _d = _a.arrows,
    arrows = _d === void 0 ? true : _d,
    _e = _a.scrollable,
    scrollable = _e === void 0 ? false : _e;
  var _f = (0, useFilter_1.useFilter)({
      filterId: filterId,
      defaultMode: "include",
      defaultOptions: defaultOptions !== null && defaultOptions !== void 0 ? defaultOptions : []
    }),
    isActive = _f.isActive,
    isUnsaved = _f.isUnsaved,
    setStateSelected = _f.setSelected,
    optionsSelected = _f.optionsSelected,
    defaultState = _f.defaultState,
    resetEvent = _f.resetEvent,
    translation = _f.translation;
  var hierarchy = (0, react_1.useMemo)(function () {
    var store = R.store("id", options);
    var rootObj = {
      id: "root",
      children: options.filter(function (o) {
        return !o.parent;
      }).map(function (o) {
        return o.id;
      })
    };
    return R.assoc("root", rootObj, store);
  }, [options]);
  var selector = (0, react_1.useMemo)(function () {
    return new Tree_1.TreeSelector({
      rootId: function () {
        return "root";
      },
      children: function (id) {
        var _a;
        return (_a = hierarchy[id].children) !== null && _a !== void 0 ? _a : [];
      },
      parent: function (id) {
        var _a;
        return (_a = hierarchy[id].parent) !== null && _a !== void 0 ? _a : id === "root" ? undefined : "root";
      },
      name: function (id) {
        var _a;
        return (_a = hierarchy[id].label) !== null && _a !== void 0 ? _a : id;
      },
      info: function (id) {
        return hierarchy[id].info;
      }
    });
  }, []);
  var _g = (0, Tree_1.useTree)(selector, {
      initialExpansion: options.filter(function (o) {
        return o.startExpanded;
      }).map(function (o) {
        return o.id;
      }),
      initialSelection: (defaultOptions !== null && defaultOptions !== void 0 ? defaultOptions : options).map(function (o) {
        return o.id;
      })
    }),
    treeState = _g.selected,
    expanded = _g.expanded,
    filterOut = _g.filterOut,
    onExpansionToggle = _g.onExpansionToggle,
    onSelectionToggle = _g.onSelectionToggle,
    setSelected = _g.setSelected,
    setFilteredOut = _g.setFilteredOut,
    setExpanded = _g.setExpanded;
  // translate tree hierarchy into optionsSelected
  var rootSelected = treeState["root"] === TriStateCheckbox_1.TriState.Full;
  var selectedValues = (0, react_1.useMemo)(function () {
    return selector.selectedIds(treeState, hierarchy).map(function (node) {
      return hierarchy[node];
    });
  }, [treeState, options]);
  var selectedCount = (0, react_1.useMemo)(function () {
    return rootSelected ? "ALL" : selectedValues.length;
  }, [selectedValues.length, rootSelected]);
  (0, react_1.useEffect)(function () {
    setStateSelected(selectedValues);
  }, [selectedValues, rootSelected]);
  // translate "optionsSelected" into tree hierarchy
  (0, react_1.useEffect)(function () {
    var OS_ids = optionsSelected.map(function (o) {
      return o.id.toString();
    });
    var newData = selector.listSelection(OS_ids, treeState, TriStateCheckbox_1.TriState.Full);
    var needsUpdate = !R.equals(newData, treeState);
    if (needsUpdate) {
      setSelected(newData);
    }
  }, [optionsSelected]);
  // reset tree state as needed
  (0, react_1.useEffect)(function () {
    var doReset = function () {
      var _a;
      setExpanded(selector.listExpansion(options.filter(function (o) {
        return o.startExpanded;
      }).map(function (o) {
        return o.id;
      })));
      setSelected(selector.listSelection(((_a = defaultState === null || defaultState === void 0 ? void 0 : defaultState.optionsSelected) !== null && _a !== void 0 ? _a : defaultOptions).map(function (o) {
        return o.id;
      })));
    };
    resetEvent.on("reset", doReset);
    return function () {
      resetEvent.off("reset", doReset);
    };
  }, []);
  // manage text filter
  var textFilterActive = (0, react_1.useMemo)(function () {
    var values = Object.values(filterOut);
    var filtered = values.filter(function (f) {
      return f === true;
    });
    var active = filtered.length > 0;
    return active;
  }, [filterOut]);
  var filter = (0, Tree_1.createFilter)(selector, 3);
  var changeFilter = function (newValue) {
    var _a = __read(filter(newValue), 1),
      filtered = _a[0];
    setFilteredOut(R.mergeRight(selector.createMap(R.F), filtered));
  };
  var onClickSelect = function (state) {
    if (!textFilterActive) {
      setSelected(selector.createMap(R.always(state)));
      return;
    }
    var nodesToChange = Object.entries(filterOut).filter(function (f) {
      return f[1] === false;
    }).filter(function (f) {
      return R.isNothing(hierarchy[f[0]].children);
    }).map(function (f) {
      return f[0];
    });
    setSelected(selector.listSelection(nodesToChange, treeState, state));
  };
  return (0, jsx_runtime_1.jsx)(Wrapper_1.FilterWrapper, __assign({
    tooltip: tooltip,
    tooltipIcon: tooltipIcon,
    tooltipColor: tooltipColor,
    tooltipIconColor: tooltipIconColor,
    filterId: filterId,
    label: label,
    isActive: isActive,
    isUnsaved: isUnsaved,
    mode: "include",
    selectedCount: selectedCount,
    startExpanded: startExpanded
  }, {
    children: (0, jsx_runtime_1.jsxs)(Stack_1.Stack, __assign({
      gap: "medium-large"
    }, {
      children: [(0, jsx_runtime_1.jsx)("div", __assign({
        className: "vsx-styled-form"
      }, {
        children: (0, jsx_runtime_1.jsx)(Form_1.Input, {
          style: {
            boxSizing: "border-box",
            fontSize: "unset"
          },
          placeholder: placeholder,
          onChange: function (e) {
            return changeFilter(e.target.value);
          }
        })
      })), (0, jsx_runtime_1.jsxs)(Row_1.Row, __assign({
        className: "button-container",
        gap: "large"
      }, {
        children: [(0, jsx_runtime_1.jsx)(Clickable_1.Clickable, __assign({
          onClick: function () {
            return onClickSelect(TriStateCheckbox_1.TriState.Full);
          }
        }, {
          children: textFilterActive ? translation.selectVisible : translation.selectAll
        })), (0, jsx_runtime_1.jsx)(Clickable_1.Clickable, __assign({
          onClick: function () {
            return onClickSelect(TriStateCheckbox_1.TriState.Empty);
          }
        }, {
          children: textFilterActive ? translation.deselectVisible : translation.deselectAll
        }))]
      })), (0, jsx_runtime_1.jsx)("div", __assign({
        className: "vsx-list-filter-container",
        style: !scrollable ? {
          display: "contents"
        } : {}
      }, {
        children: (0, jsx_runtime_1.jsx)(Tree_1.Tree, {
          arrows: arrows,
          treeStructure: selector,
          fixedWidth: true,
          selected: treeState,
          expanded: expanded,
          filterOut: filterOut,
          onExpansionToggle: onExpansionToggle,
          onSelectionToggle: onSelectionToggle
        })
      }))]
    }))
  }));
};